import script from "./EmailTemplatesBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailTemplatesBox.vue?vue&type=script&setup=true&lang=js"

import "./EmailTemplatesBox.vue?vue&type=style&index=0&id=d5a849c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5a849c0"]])

export default __exports__